import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0a9 9 0 0 0-9 9c0 4.971 4.029 9 9 9s9-4.029 9-9a9 9 0 0 0-9-9zm0 16.8c-4.301 0-7.8-3.499-7.8-7.8S4.699 1.2 9 1.2s7.8 3.499 7.8 7.8-3.499 7.8-7.8 7.8zM9.302 9h1.697l3-3-3-3H9.302l2.4 2.4H4v1.2h7.702L9.302 9zm-.604 0H7.002l-3 3 3 3h1.697l-2.4-2.4H14v-1.2H6.298l2.4-2.4z" />
  </svg>
);

export default SvgComponent;
